// This must be in sync with src/types/v2/defs/flags.ts -
// Any changes here should be reflected there as well
export type FeatureFlagKey = 'streamability' | 'chatHistory';
export const featureFlags: Record<FeatureFlagKey, boolean> = {
  chatHistory: true,
  streamability: false,
};
